import React from "react";
import { useQuery } from "@tanstack/react-query";
import { auth } from "../../../components/Auth/Auth.jsx";

const GetDevicesSettings = async (deviceIds, indefinite = false) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  if (!deviceIds) {
    return null;
  }

  const token = await user.getIdToken();

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/setting/devices`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // Send the settings type so the backend can select the correct container.
      body: JSON.stringify({
        deviceIds,
        indefinite,
      }),
    },
  );
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthorized: Please log in again.");
    }
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const UseDeviceSettings = (
  deviceIds,
  indefinite = false,
  options = {},
) => {
  const hasDeviceIds = Array.isArray(deviceIds) && deviceIds.length > 0;

  const { data, isPending, error, refetch } = useQuery({
    // Keep separate cache entries for scheduled and indefinite settings.
    queryKey: ["deviceSettings", deviceIds, indefinite],
    queryFn: () => GetDevicesSettings(deviceIds, indefinite),
    enabled: options.enabled ?? hasDeviceIds,

    // Do not automatically refetch when the browser window regains focus.
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,

    // Do not automatically refetch when the network reconnects.
    refetchOnReconnect: options.refetchOnReconnect ?? false,

    // Do not automatically refetch cached data when the component mounts again.
    refetchOnMount: options.refetchOnMount ?? false,
  });

  return { data, isPending, error, refetch };
};
